<button class="btn btn-primary btn-lg" (click)="select()">{{'SELECT'|translate}}</button>
